import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ToastComponent } from '@shared/components/toast/toast.component';
import { CcsLoaderComponent } from '@shared/components/ccs-loader/ccs-loader.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, CcsLoaderComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {}
